export default __webpack_public_path__ + "static/media/bg.c6f703cf.png";